<template>
    <div>
        <v-tooltip
            transition="custom-tooltip"
            open-delay="150"
            bottom
            z-index="99"
            offset-overflow
            nudge-bottom="4px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-chip
                    small
                    v-on="on"
                    href="#"
                    v-bind="attrs"
                    color="sand darken-1"
                    :class="isSmall ? 'v-chip--small':''"
                >
                    <v-icon :size="isSmall ? '14':'18'" color="white" class="mr-1">$collaborate</v-icon>
                    <v-icon size="15" color="white" class="icon-arrow mr-1">$arrowRightSm</v-icon>
                </v-chip>
            </template>
            <span v-html="$t('tooltip.instance.collaborate.start')"></span>
        </v-tooltip>
    </div>
  </template>
  
  <script>

  
  export default {
    props: {
      isSmall: Boolean,
      instance: Object,
    },
    components: {
    },
    computed: {
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .v-chip {
    border-radius: 4px;
    font-size: $font-size-xxs;
    line-height: $line-height-xxs;
    color: white;
    font-weight: $font-weight-semibold;
    width: 50px;
    max-width: 50px;
    height: 28px;
    padding: 4px 8px;
    &:active,
    &:focus{
        box-shadow: none;
    }
    &--small{
        width: 37px;
        max-width: 37px;
        padding: 4px 4px;
        height: 24px;
    }
    .icon-arrow{
        margin-left: -3px;
    }
  }
  
  
  </style>